var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"6jZTxz9F639_Wsd7zozW_"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the intialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { beforeSend, beforeBreadcrumb } from './utils/sentry-privacy';

const SENTRY_DSN = process.env.SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.SOMIS_ENV,
  // Spec decision D6. peikko had none of this: no scrubbing hooks and not even
  // sendDefaultPii, on the flow where phone numbers and email addresses are typed.
  // Sentry's defaults would otherwise decide what leaves — console output, fetch and
  // navigation URLs, and DOM input breadcrumbs. See utils/sentry-privacy.ts.
  sendDefaultPii: false,
  beforeSend,
  beforeBreadcrumb,
});
